// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"39f271e8","38":"68c6891f","872":"4aff0d20"}[chunkId] + ".chunk.js";
};